const Megogo = window.Megogo || {};
export const { scopeLogger = () => window.console } = Megogo;
